import httpService from '@Utils/httpService';

/**
 * Consent step of AVA's MCP OAuth flow (AVA-560). The API holds the pending request an AI assistant
 * started; the signed-in user approves or denies it here with their normal AVA session.
 * Controller: MODS.Forge.Api/Controllers/Accounts/McpOAuthConsentController.cs.
 */
const baseUrl = 'api/oauth/requests';

export default {
  /** What the consent screen shows. 404 = expired or already answered. */
  getRequest(requestId) {
    return httpService.get({ url: `${baseUrl}/${encodeURIComponent(requestId)}` });
  },

  /** Approve: resolves to { redirectUrl } carrying the single-use code (and state). */
  approve(requestId) {
    return httpService.post({ url: `${baseUrl}/${encodeURIComponent(requestId)}/approve` });
  },

  /** Deny: resolves to { redirectUrl } carrying error=access_denied (and state). */
  deny(requestId) {
    return httpService.post({ url: `${baseUrl}/${encodeURIComponent(requestId)}/deny` });
  },
};
